module.exports = __webpack_public_path__ + "media/images/icons/dot-icon-887cba6cdd25a9dab9f36b42a7a3dbd5.svg";